import { render } from "./accordion-header.vue?vue&type=template&id=bd3a2778"
import script from "./accordion-header.vue?vue&type=script&lang=js"
export * from "./accordion-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__